// 出库路由

export default {
  path: "/outWarehouse",
  name: "outWarehouse",
  meta: { title: "出库管理", icon: "out-warehouse" },
  children: [
    {
      path: "/outWarehouse/commonOutWarehouse",
      name: "commonOutWarehouse",
      component: () =>
        import(
          /* webpackChunkName: "commonOutWarehouse" */ "@/views/warehouse/outWarehouse/commonOutWarehouse/index.vue"
        ),
      meta: { title: "普通出库", icon: "commonOutWarehouse" },
    },
    {
      path: "/outWarehouse/retailOutWarehouse",
      name: "retailOutWarehouse",
      component: () =>
        import(
          /* webpackChunkName: "retailOutWarehouse" */ "@/views/warehouse/outWarehouse/retailOutWarehouse/index.vue"
        ),
      meta: { title: "零售出库", icon: "retailOutWarehouse" },
    },
    {
      path: "/outWarehouse/productionWarehouse",
      name: "productionWarehouse",
      component: () =>
        import(
          /* webpackChunkName: "productionWarehouse" */ "@/views/warehouse/outWarehouse/productionWarehouse/index.vue"
        ),
      meta: { title: "生产出库", icon: "productionWarehouse" },
    },
    {
      path: "/outWarehouse/procureOutWarehouse",
      name: "procureOutWarehouse",
      component: () =>
        import(
          /* webpackChunkName: "procureOutWarehouse" */ "@/views/warehouse/outWarehouse/procureOutWarehouse/index.vue"
        ),
      meta: { title: "项目出库", icon: "procureWarehouse" },
    },
    {
      path: "/outWarehouse/returnOutWarehouse",
      name: "returnOutWarehouse",
      component: () =>
        import(
          /* webpackChunkName: "returnOutWarehouse" */ "@/views/warehouse/outWarehouse/returnOutWarehouse/index.vue"
        ),
      meta: { title: "退货出库", icon: "returnOutWarehouse" },
    },
    {
      path: "/outWarehouse/allocationOutWarehouse",
      name: "allocationOutWarehouse",
      component: () =>
        import(
          /* webpackChunkName: "allocationOutWarehouse" */ "@/views/warehouse/outWarehouse/allocationOutWarehouse/index.vue"
        ),
      meta: { title: "调拨出库", icon: "allocationOutWarehouse" },
    },
  ],
};
